<template>
    <div class="pb-5">
        <template v-if="inputLbl.name != null">
            <div class="text-base text-primary mb-10px">{{ inputLbl.name }}</div>
        </template>
        <div class="grid gap-4" :class="gridClassComputed">
            <template v-for="item of items" :key="`rad-input-${item.value}`">
                <div :class="radioClass(item)">
                    <div
                        class="flex items-center"
                        :for="`rad-lbl-${item.value}`"
                        @click="selectRadio(item.value)"
                    >
                        <div
                            class="radio w-5 h-5 rounded-full flex items-center justify-center"
                            :class="[value == item.value ? 'active border border-none' : 'border border-primary']"
                        >
                            <transition
                                enter-active-class="transition ease-out duration-500"
                                enter-from-class="transform opacity-0 scale-50"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-100"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-50"
                            >
                                <div
                                    v-if="value == item.value"
                                    class="bg-white w-10px h-10px rounded-full"
                                ></div>
                            </transition>
                        </div>
                        <div class="pl-3 flex-auto text-primary">{{ item.text }}</div>
                    </div>
                </div>
            </template>
        </div>

        <div class="text-red-500 text-sm absolute bottom-0 left-0" v-if="isError">{{ getErrorMsg }}</div>
    </div>
</template>
<script>
import Util from "@/helper/Utility"

export default {
    name: "InputRadioGroup",
    props: {
        inputValue: {
            type: [String, Number]
        },
        errorInfo: { type: Object, required: true },
        isFirstSave: { type: Boolean, default: true },
        isShowErrorLbl: { type: Boolean, default: false },
        inputLbl: { type: Object, required: true },
        items: {
            type: Array,
            default: () => []
        },
        cols: {
            type: Number,
            default: 1
        },
    },
    emits: ["update:inputValue"],
    computed: {
        value: {
            get: function () {
                return this.inputValue
            },
            set: function (newVal) {
                this.$emit("update:inputValue", newVal)
            }
        },
        gridClassComputed: function () {
            let cls = []

            cls.push(`grid-cols-${this.cols}`)

            return cls
        },
        isError: function () {
            if (this.isShowErrorLbl && !this.isFirstSave && !this.errorInfo.isValid) {
                return true;
            }
            return false;
        },
        getErrorMsg: function () {
            if (this.isShowErrorLbl && !this.isFirstSave && !this.errorInfo.isValid) {
                return this.errorInfo.msg;
            }
            return '';
        },
    },
    watch:{
        inputValue: function(val){
            this.validateInput(val)
        }
    },
    mounted: function () {
        this.validateInput(this.inputValue)
    },
    methods: {
        radioClass: function (item) {
            let cls = []
            if (item.cols != undefined) {
                if (item.cols == 2) {
                    cls.push("col-span-2")
                } else if (item.cols == 3) {
                    cls.push("col-span-3")
                }
            }

            return cls
        },
        selectRadio: function (value) {
            // console.log(this.validate(value))
            if (this.validateInput(value)) {
                this.value = value
            }
        },
        validateInput: function (value) {
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');

            if (this.inputLbl.required && Util.isEmptyStr(value)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required);
                return false;
            }

            return true
        },
    }
}
</script>

<style lang="scss" scoped>
.radio {
    background-color: #fff;
    &.active {
        background-image: linear-gradient(to right, #72292f 0%, #e00238 100%);
    }
}
</style>
